import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Helmet } from 'react-helmet-async';

// pakai gambar yang sudah ada di project
import heroAtto1 from '../images/kv-pc.jpg';
import exteriorAtto1 from '../images/07-01-pc-01.webp';
import interiorAtto1 from '../images/10-pc.jpg';
import colorAtto1 from '../images/04-black.webp';

function Atto1Junius() {
  const waLink =
    'https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20mau%20info%20BYD%20Atto%201%20dari%20Junius%20di%20BYD%20BSD%20Serpong';

  return (
    <Box
      sx={{
        padding: { xs: 2, sm: 4 },
        maxWidth: '1200px',
        margin: '0 auto',
      }}
    >
      <Helmet>
        <title>
          BYD Atto 1 BSD Serpong Junius | Harga, Spesifikasi, Promo & Test Drive
        </title>
        <meta
          name='description'
          content='Cari BYD Atto 1 di BYD BSD Serpong Junius? Lihat info harga, spesifikasi, warna, fitur, promo, dan jadwal test drive BYD Atto 1 di BSD Serpong.'
        />
        <meta
          name='keywords'
          content='BYD Atto 1, BYD Atto1, BYD BSD Serpong Junius, Atto 1 Junius, harga BYD Atto 1 BSD Serpong, dealer BYD BSD Serpong, test drive BYD Atto 1, promo BYD Atto 1'
        />
        <meta name='author' content='BYD BSD Serpong Junius' />
        <link
          rel='canonical'
          href='https://bydbsdserpong.com/blog/byd-atto-1-bsd-serpong-junius'
        />

        <meta
          property='og:title'
          content='BYD Atto 1 BSD Serpong Junius | Harga, Promo & Test Drive'
        />
        <meta
          property='og:description'
          content='Temukan info lengkap BYD Atto 1 bersama Junius di BYD BSD Serpong. Cek spesifikasi, warna, promo, dan booking test drive.'
        />
        <meta
          property='og:url'
          content='https://bydbsdserpong.com/blog/byd-atto-1-bsd-serpong-junius'
        />
        <meta property='og:type' content='article' />
        <meta
          property='og:image'
          content='https://bydbsdserpong.com/static/media/kv-pc.jpg'
        />

        <meta name='twitter:card' content='summary_large_image' />
        <meta
          name='twitter:title'
          content='BYD Atto 1 BSD Serpong Junius | Harga, Promo & Test Drive'
        />
        <meta
          name='twitter:description'
          content='Info lengkap BYD Atto 1 di BYD BSD Serpong Junius. Lihat harga, spesifikasi, dan jadwal test drive.'
        />
        <meta
          name='twitter:image'
          content='https://bydbsdserpong.com/static/media/kv-pc.jpg'
        />

        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline:
              'BYD Atto 1 BSD Serpong Junius | Harga, Spesifikasi, Promo & Test Drive',
            description:
              'Informasi lengkap BYD Atto 1 di BYD BSD Serpong Junius, mulai dari harga, spesifikasi, fitur, warna, hingga test drive.',
            author: {
              '@type': 'Person',
              name: 'Junius',
            },
            publisher: {
              '@type': 'Organization',
              name: 'BYD BSD Serpong',
            },
            mainEntityOfPage:
              'https://bydbsdserpong.com/blog/byd-atto-1-bsd-serpong-junius',
            image: ['https://bydbsdserpong.com/static/media/kv-pc.jpg'],
          })}
        </script>

        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'Di mana bisa beli BYD Atto 1 di BSD Serpong?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Anda bisa menghubungi Junius di BYD BSD Serpong untuk informasi unit, promo, booking test drive, dan simulasi pembelian BYD Atto 1.',
                },
              },
              {
                '@type': 'Question',
                name: 'Apakah BYD Atto 1 cocok untuk mobilitas harian?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'BYD Atto 1 cocok untuk mobilitas harian karena ukurannya kompak, mudah dikendarai di area urban, dan memiliki fitur modern untuk penggunaan kota.',
                },
              },
              {
                '@type': 'Question',
                name: 'Bagaimana cara test drive BYD Atto 1 di BYD BSD Serpong?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Anda bisa menghubungi Junius melalui WhatsApp untuk menjadwalkan test drive BYD Atto 1 di BYD BSD Serpong.',
                },
              },
            ],
          })}
        </script>
      </Helmet>

      <br />
      <br />
      <br />
      <br />

      <Typography variant='h3' component='h1' fontWeight='bold' gutterBottom>
        BYD Atto 1 BSD Serpong Junius: Info Harga, Spesifikasi, Promo, dan Test
        Drive
      </Typography>

      <Typography
        variant='body1'
        paragraph
        sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}
      >
        Jika Anda sedang mencari <strong>BYD Atto 1</strong> di area BSD,
        Serpong, Tangerang, dan sekitarnya, halaman ini dibuat khusus untuk
        membantu Anda mendapatkan informasi yang paling relevan. Bersama{' '}
        <strong>Junius di BYD BSD Serpong</strong>, Anda bisa melihat gambaran
        lengkap mulai dari desain, fitur, pilihan warna, hingga proses booking
        test drive dan konsultasi pembelian.
      </Typography>

      <Box sx={{ my: 4 }}>
        <img
          src={heroAtto1}
          alt='BYD Atto 1 BSD Serpong Junius'
          style={{ width: '100%', borderRadius: 12, display: 'block' }}
          loading='lazy'
        />
      </Box>

      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Kenapa BYD Atto 1 Menarik untuk Mobilitas Harian
        </Typography>

        <Typography variant='body1' paragraph>
          <strong>BYD Atto 1</strong> hadir sebagai mobil listrik kompak yang
          cocok untuk penggunaan harian di kota. Ukurannya ringkas, mudah
          bermanuver, dan tetap menawarkan tampilan modern. Untuk pengguna yang
          ingin masuk ke dunia EV dengan mobil yang praktis dan efisien, Atto 1
          jadi pilihan yang relevan.
        </Typography>

        <Typography variant='body1' paragraph>
          Untuk area BSD dan sekitarnya, mobil seperti ini punya nilai lebih
          karena cocok dipakai untuk perjalanan rumah-kantor, aktivitas harian,
          maupun kebutuhan keluarga kecil. Dari sisi desain, Atto 1 juga punya
          karakter yang lebih muda, urban, dan mudah diterima oleh first-time EV
          buyer.
        </Typography>
      </Box>

      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Desain Eksterior yang Ringkas dan Modern
        </Typography>

        <img
          src={exteriorAtto1}
          alt='Eksterior BYD Atto 1 di BYD BSD Serpong'
          style={{
            width: '100%',
            marginBottom: 16,
            borderRadius: 12,
            display: 'block',
          }}
          loading='lazy'
        />

        <Typography variant='body1' paragraph>
          Salah satu daya tarik utama <strong>BYD Atto 1</strong> adalah desain
          luarnya yang simpel namun tetap modern. Proporsi bodi yang kompak
          membuat mobil ini nyaman dipakai di jalan perkotaan, parkir basement,
          hingga area padat. Buat konsumen yang mencari city car EV dengan
          tampilan kekinian, Atto 1 punya positioning yang kuat.
        </Typography>
      </Box>

      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Interior dan Fitur yang Relevan untuk Penggunaan Kota
        </Typography>

        <img
          src={interiorAtto1}
          alt='Interior BYD Atto 1 di BSD Serpong'
          style={{
            width: '100%',
            marginBottom: 16,
            borderRadius: 12,
            display: 'block',
          }}
          loading='lazy'
        />

        <Typography variant='body1' paragraph>
          Di bagian interior, <strong>BYD Atto 1</strong> menawarkan layout
          kabin yang modern dan fungsional. Fokusnya bukan hanya tampilan, tapi
          juga kemudahan penggunaan sehari-hari. Untuk konsumen yang
          prioritasnya kenyamanan, visibilitas, dan efisiensi ruang, Atto 1
          punya keunggulan yang cukup menarik di kelas mobil listrik kompak.
        </Typography>

        <Typography variant='body1' paragraph>
          Halaman ini juga melengkapi konten lain di website kamu seperti warna,
          interior, eksterior, dan fitur Atto 1, jadi secara internal linking
          juga lebih kuat untuk keyword turunannya.
        </Typography>
      </Box>

      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Pilihan Warna BYD Atto 1
        </Typography>

        <img
          src={colorAtto1}
          alt='Pilihan warna BYD Atto 1'
          style={{
            width: '100%',
            marginBottom: 16,
            borderRadius: 12,
            display: 'block',
          }}
          loading='lazy'
        />

        <Typography variant='body1' paragraph>
          Banyak calon pembeli juga mencari informasi soal warna sebelum datang
          ke showroom. Karena itu, page ini bisa bantu mengarahkan pengunjung ke
          artikel pendukung lain tentang <strong>warna BYD Atto 1</strong>,
          interior, dan eksterior agar mereka lebih lama berada di website dan
          lebih siap saat konsultasi.
        </Typography>
      </Box>

      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          Kenapa Cari “BYD BSD Serpong Junius” dan “Atto 1 Junius”
        </Typography>

        <Typography variant='body1' paragraph>
          Banyak orang mencari nama sales atau advisor langsung saat mereka
          sudah punya intent beli. Karena itu, keyword seperti{' '}
          <strong>BYD BSD Serpong Junius</strong> dan{' '}
          <strong>Atto 1 Junius</strong> bagus untuk ditarget secara natural di
          satu halaman khusus seperti ini. Fokus page ini bukan spam keyword,
          tapi memperjelas bahwa Junius adalah kontak yang bisa dihubungi untuk
          konsultasi unit, test drive, promo, dan ketersediaan BYD Atto 1 di BSD
          Serpong.
        </Typography>
      </Box>

      <Box sx={{ my: 6 }}>
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          FAQ Singkat tentang BYD Atto 1
        </Typography>

        <Typography variant='body1' paragraph>
          <strong>Apakah BYD Atto 1 cocok untuk pemakaian harian?</strong>
          <br />
          Ya, mobil ini cocok untuk kebutuhan urban dan penggunaan rutin dengan
          karakter yang ringkas dan praktis.
        </Typography>

        <Typography variant='body1' paragraph>
          <strong>Apakah bisa test drive di BSD Serpong?</strong>
          <br />
          Bisa. Anda dapat menghubungi Junius untuk menjadwalkan test drive
          sesuai ketersediaan unit.
        </Typography>

        <Typography variant='body1' paragraph>
          <strong>Bagaimana cara tanya harga BYD Atto 1?</strong>
          <br />
          Paling cepat melalui WhatsApp agar Anda bisa langsung dapat info unit,
          promo, dan simulasi pembelian.
        </Typography>
      </Box>

      <Paper
        sx={{
          p: 4,
          mt: 6,
          backgroundColor: '#e3f2fd',
          borderLeft: '6px solid #1976d2',
          borderRadius: 2,
        }}
      >
        <Typography variant='h5' fontWeight='bold' gutterBottom>
          Mau Info BYD Atto 1 dari Junius di BYD BSD Serpong?
        </Typography>
        <Typography variant='body1'>
          Untuk info harga, promo, ketersediaan unit, dan booking test drive,
          klik WhatsApp di bawah.
        </Typography>

        <Box sx={{ mt: 1 }}>
          <a href={waLink} target='_blank' rel='noopener noreferrer'>
            Chat WhatsApp — BYD Atto 1 Junius
          </a>
        </Box>
      </Paper>
    </Box>
  );
}

export default Atto1Junius;
